var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefineMessageComposerDisableIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gray",
    transform: "translate(-892 -632)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161736",
    "data-name": "Group 161736",
    transform: "translate(0.37 -0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83717",
    "data-name": "Path 83717",
    d: "M36.363,47.034,46.936,36.461a1.243,1.243,0,0,1,1.717,0l1.57,1.57a1.216,1.216,0,0,1,0,1.717L39.651,50.322a1.216,1.216,0,0,1-1.717,0l-1.571-1.57A1.214,1.214,0,0,1,36.363,47.034Zm13-8.145-1.57-1.57-3.036,3.036,1.571,1.571,3.036-3.036ZM38.792,49.463l6.679-6.678L43.9,41.214l-6.679,6.679Z",
    transform: "translate(856.122 599.323)",
    fill: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83718",
    "data-name": "Path 83718",
    d: "M14.429,85.214,13.214,84,12,85.214l1.214,1.214Z",
    transform: "translate(894.702 556.286)",
    fill: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83719",
    "data-name": "Path 83719",
    d: "M86.429,13.214,85.214,12,84,13.214l1.214,1.214Z",
    transform: "translate(815.416 621)",
    fill: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83720",
    "data-name": "Path 83720",
    d: "M14.429,13.214,13.214,12,12,13.214l1.214,1.214Z",
    transform: "translate(894.702 621)",
    fill: "#a0a0a0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_83721",
    "data-name": "Path 83721",
    d: "M0,0H18V18H0Z",
    transform: "translate(892 632)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefineMessageComposerDisableIcon);
export default __webpack_public_path__ + "static/media/refine-message-composer-disable-icon.a43314302f29c93f472246fe856052ff.svg";
export { ForwardRef as ReactComponent };